import React, {useEffect, useCallback, useState} from 'react'
import {Grid, FormControl, InputLabel, MenuItem, FormHelperText} from '@material-ui/core'
import _ from 'lodash'
import Select from 'react-select'
import useReservedForFieldValuesReducer from '../../../state/reservation/reserved-for-field-values/reducer'
import {getReservedForFieldValues} from '../../../state/reservation/reserved-for-field-values/actions'
import './StepActionField.scss'
import WListField from './SListField'
import ChildGroupListField from './ChildGroupListField'

let childOptionList = []
export default function WMemoField({fieldId, fieldType, data, onChange, itemSelected, tabActive}) {
  const [search, setSearch] = useState('')
  const [optionList, setOptionList] = useState([])
  // const [childOptionList, setChildOptionList] = useState([])

  const [list, reservedForFieldValuesDispatch] = useReservedForFieldValuesReducer()
  const isTrue = itemSelected?.reserve_for?.field_id.includes(`${data.id}`)
  const newoptionList = []

  const getOptionList = userList => {
    if (userList) {
      if (!userList.isLoading) {
        if (userList.data) {
          const newOptionList = userList.data.map(fv => ({
            value: fv.id,
            label: fv.name,
            is_child: fv?.is_child,
            associated_object: fv.associated_objects,
          }))

          return setOptionList(newOptionList)
        }
      }
    }
  }

  useEffect(() => {
    getReservedForFieldValues(
      reservedForFieldValuesDispatch,
      [fieldId],
      fieldType,
      search
    ).then(res => getOptionList(res))
    // eslint-disable-next-line
  }, [fieldType, reservedForFieldValuesDispatch, search, fieldId])

  useEffect(() => {
    if (isTrue) {
      let selected = itemSelected?.reserve_for?.value_id
      onChange(null, data.key, selected)
    }
    childOptionList = []
    // eslint-disable-next-line
  }, [])

  const onSetOption = (e, data_key) => {
    onChange(null, data_key, e?.value)

    const newData = e.associated_object
    const newArr = []
    newData.length &&
      newData.map((fv, i) => {
        newArr.push({
          value: fv.value,
          label: fv.text,
          parent: fv.secondary_value,
        })
        return newArr
      })
    if (!_.isEmpty(newArr)) {
      childOptionList = [...newArr]
    } else {
      childOptionList = []
    }
  }

  return (
    <>
      {data.is_parent && (
        <Grid item xs={6} className="select-search-container">
          <InputLabel id="demo-mutiple-name-label">
            <small>{data.name}</small>
          </InputLabel>
          <Select
            classNamePrefix="select"
            className="select-search"
            isSearchable={true}
            isLoading={list.isLoading}
            labelId="demo-mutiple-name-label"
            id="demo-simple-select"
            placeholder={isTrue ? itemSelected?.reserve_for?.value : data.name}
            options={optionList}
            onChange={e => {
              onSetOption(e, data.key)
            }}
            onInputChange={e => setSearch(e)}
            isDisabled={isTrue ? true : false}
          />
          <FormHelperText className="ap-textfield">
            {(() => {
              if (
                (tabActive === 'upcoming' && data.is_required) ||
                (tabActive === 'ongoing' && data.is_required_return)
              ) {
                return 'required*'
              } else {
                return 'optional'
              }
            })()}
          </FormHelperText>
        </Grid>
      )}
      {data.is_child && (
        <ChildGroupListField
          data={data}
          childOptionList={childOptionList}
          onChange={onChange}
          itemSelected={itemSelected}
          tabActive={tabActive}
        />
      )}
    </>
  )
}
